import { useRef } from 'react';
import { EventsCardModal } from '../../../../../components/Module/Events/Components/EventsCard';
import { useMapWidgetStore } from '../MapWidgetContext';
import { EventsActivator, EventsActivatorProps } from './Activator';
import { EventsContext } from './context';
import { MapWidgetEventsStore } from './store';

interface EventsInitializerProps extends Pick<EventsActivatorProps, 'status'> {
  children?: React.ReactNode;
}

export const EventsInitializer = ({
  children,
  status,
}: EventsInitializerProps) => {
  const { map, mouseController } = useMapWidgetStore();

  const storeRef = useRef(
    new MapWidgetEventsStore(map.mapProperties, mouseController),
  );

  const store = storeRef.current;

  return (
    <EventsContext.Provider value={store}>
      <EventsActivator status={status}>
        <EventsCardModal card={store.card} />
      </EventsActivator>

      {children}
    </EventsContext.Provider>
  );
};
